

import { FC, useContext, useEffect, useState } from "react";

import { format } from "date-fns";
import DatePicker from "react-datepicker";
import { UploadProps } from "src/components/uploadEOBs/types";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import { RequestTreatmentNotTreatingApiResponse } from "../requestDateOfTreatment/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";

const MarkCaseCEP: FC<UploadProps> = ({ onClose }): JSX.Element => {

  const [caseId, setCaseId] = useState<string>(localStorage.getItem("CaseId")||'');
  const [treatmentDate, setTreatmentDate] = useState<Date | null>(null);
  const { data: requestTreatmentData, mutate: updateRequestTreatment, error: treatmentUpdateError } = useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.REQUEST_TREATMENT_NOT_TREATING, {}, {},false)
  const { showToast } = useContext(ToastContext);
   
  const prescriptionId=localStorage.getItem("PrescriptionId") || ''
  const handleSave = () => {
    if (!treatmentDate) {
      alert("Please select a treatment date");
      return;
    }
  

    const formattedDate = format(treatmentDate, "yyyy-MM-dd");
    //console.log("Saving case:", caseId, "with date:", formattedDate);
    
    const requestBody = {
          "prescription": {
            "bentype":'cep',
            'case_id':caseId,
            "schdeuled_date_of_service": formattedDate,
            
          }
        }
        updateRequestTreatment(requestBody,{caseId,prescriptionId})
  }

  useEffect(() => {
      if (requestTreatmentData || treatmentUpdateError) {
        setTreatmentDate(null)
        if(requestTreatmentData) {
          const { code } = requestTreatmentData;
          if (code === 200) {
            showToast([`Request Treatment Scheduled Successfully`], ToastTypes.SUCCESS);
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestTreatmentData, treatmentUpdateError]);

    return (
      <div className="modal show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }} onClick={onClose} >
        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content shadow">
            <div className="modal-header">
              <h3 className="modal-title">
                Mark Case CEP
              </h3>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="card mb-4">
                <div className="card-body">
                  <p className="text-lg mb-6">Please specify date of treatment...</p>

                  <div className="row">
                    <div className="col-6">
                    <label className="block text-sm font-medium text-gray-700 m-1">Case</label>
                    <input
                      type="text"
                      value={caseId}
                      placeholder="Case ID"
                      onChange={(e) => setCaseId(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
                    />
                  </div>

                  <div className="col-6">
                    <label className="block text-sm font-medium text-gray-700 m-1">Date</label>
                    <DatePicker
                       selected={treatmentDate}
                      onChange={(date) => setTreatmentDate(date)}
                       placeholderText="mm/dd/yyyy"
                      dateFormat="MM/dd/yyyy"
                      showMonthDropdown
                      showYearDropdown
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    
                  </div>
                  </div>
                </div>

                <div className="text-end m-2">
                  <button
                    onClick={handleSave}
                    className="btn btn-blue"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  export default MarkCaseCEP;
